import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '@/components/Logo';

/**
 * Shared site footer used across most pages.
 * Single source of truth so links + branding stay in sync.
 */
const Footer = () => {
  return (
    <footer className="relative z-10 border-t border-border/50 py-8 px-4 sm:px-6 lg:px-8 mt-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto flex flex-col gap-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <Logo size="sm" />
          </div>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/pricing" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Pricing</Link>
            <Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors">About</Link>
            <Link to="/faq" className="text-sm text-muted-foreground hover:text-foreground transition-colors">FAQ</Link>
            <Link to="/affiliate-interest" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Earn with Poettik</Link>
            <Link to="/free-violation-appeal" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-free-violation-link">Free violation appeal</Link>
            <Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-contact-link">Contact</Link>
            <Link to="/support" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Support</Link>
            <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Privacy</Link>
            <Link to="/cookies" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Cookies</Link>
            <p className="text-sm text-muted-foreground">
              &copy; {new Date().getFullYear()} Poettik. All rights reserved.
            </p>
          </div>
        </div>
        <div className="border-t border-border/40 pt-5 flex flex-col items-center gap-1 text-center">
          <p className="text-xs text-muted-foreground/80" data-testid="footer-legal-line">
            Poettik is a trading name of VZV Ltd, a company registered in England and Wales (Company No. 10689932).
          </p>
          <p className="text-xs text-muted-foreground/70">
            Questions?{' '}
            <Link to="/contact" className="underline underline-offset-2 hover:text-foreground transition-colors">Contact us</Link>
            {' '}or email{' '}
            <a href="mailto:hey@poettik.com" className="underline underline-offset-2 hover:text-foreground transition-colors">hey@poettik.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
